import { privateApi, createPrivateClient } from './api';
import type { SelectedCard } from '../types/recharge';

// Cliente sem interceptor de 401 — evita que um 401 no polling de status
// dispare o handler de sessão expirada durante uma transação em andamento.
const pollingClient = createPrivateClient();

const rechargeService = {
  getLastRecharge: (msisdn: string) =>
    privateApi.get(`/customers/${msisdn}/last-recharge`),

  sendCreditRecharge: (
    msisdn: string,
    targetMsisdn: string | null,
    card: SelectedCard | null,
    rechargeValueId: number,
  ) =>
    privateApi.post(`/customers/${msisdn}/recharges/async`, {
      msisdnRecebedor: targetMsisdn,
      rechargeValueId,
      card,
      authenticationType: '3ds2',
    }),

  getRechargeStatus: (msisdn: string, cid: string, rid: string) =>
    pollingClient.get(`/customers/${msisdn}/uuid/${cid}/recharges/${rid}`),
};

export default rechargeService;
